export default __webpack_public_path__ + "72f01c4b8ed26d05e8776e7ee3c524fe.png";